/** Drag data of a row of the workspace board-label catalog. */
export const labelDragData = (labelId: string) => ({ type: 'workspace-board-label', labelId });

export function isLabelDrag(
  data: Record<string | symbol, unknown>,
): data is Record<string | symbol, unknown> & ReturnType<typeof labelDragData> {
  return data.type === 'workspace-board-label' && typeof data.labelId === 'string';
}
